function sliderWithTabs() {
    'use strict';

    const el = $('.js_sliderWithTabs');
    const args = {
        rows: false,
        dots: false,
        infinite: false,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 15000,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        speed: 1200,
        prevArrow: '<button class="slick-prev prevArrow" aria-label="Previous" type="button"><svg xmlns="http:/T/www.w3.org/2000/svg" viewBox="0 0 192 512" fill="currentColor"><path d="M4.2 247.5L151 99.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17L69.3 256l118.5 119.7c4.7 4.7 4.7 12.3 0 17L168 412.5c-4.7 4.7-12.3 4.7-17 0L4.2 264.5c-4.7-4.7-4.7-12.3 0-17z"/></svg><span class="sr-only">Previous</span></button>',
        nextArrow: '<button class="slick-next nextArrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" fill="currentColor"><path d="M187.8 264.5L41 412.5c-4.7 4.7-12.3 4.7-17 0L4.2 392.7c-4.7-4.7-4.7-12.3 0-17L122.7 256 4.2 136.3c-4.7-4.7-4.7-12.3 0-17L24 99.5c4.7-4.7 12.3-4.7 17 0l146.8 148c4.7 4.7 4.7 12.3 0 17z"/></svg><span class="sr-only">Next</span></button>',
        responsive: [{
            breakpoint: 670,
            settings: {
                arrows: false,
                dots: true
            }
        }]
    }

    el.each(function(index) {
        // add class so we can select individual sliders
        $(this).addClass('asideSlider' + index);
        const slider = $('.asideSlider' + index);

        // init slick on our const
        slider.slick(args);

        const parent = slider.parents('.sliderWithTabsMain');
        const tabsMenu = parent.find('.sliderTabsMenu');
        let currentSlideIndex = slider.slick('slickCurrentSlide');

        // add active class to menu
       tabsMenu.find('> li [data-slide=' + currentSlideIndex +']').parent().addClass('active');

       parent.on('click', '.sliderTabsMenu button', function (e) {
           currentSlideIndex = slider.slick('slickCurrentSlide');
           const slideIndex = $(e.target).data('slide');

           // check if the current slide index is different as slick loses its place
           if (currentSlideIndex !== slideIndex) {
               // set slick index from tabs menu
               slider.slick('slickGoTo', slideIndex);

               // remove active class from old el
               tabsMenu.find('> li').removeClass('active');

               // update active item with class
               $(this).closest('li').addClass('active');
           }
       });

        slider.on('beforeChange', function (_, __, ___, nextSlide) {
            // remove active class from old el
            tabsMenu.find('> li').removeClass('active');

            // update active item with class
            tabsMenu.find('> li [data-slide=' + nextSlide +']').parent().addClass('active');
        });

    });
}

$(document).ready(function () {
    'use strict';

    if ($('.js_sliderWithTabs').length) {
        sliderWithTabs();
    }

});